import { useStore } from '@nanostores/react';
import { atom } from 'nanostores';
import { Button, Modal, ModalBody, ModalFooter, Paragraph, Strong } from '@customerio/pluma-components/react';

type ConfirmAbortState = { proceed: () => void; abort: () => void } | null;
const $confirmAbortModal = atom<ConfirmAbortState>(null);

export function useConfirmAbortUploadModal() {
  const state = useStore($confirmAbortModal);
  return {
    isOpen: state !== null,
    state,
    show: (data: NonNullable<ConfirmAbortState>) => {
      $confirmAbortModal.set(data);
      return Promise.resolve();
    },
    close: () => {
      $confirmAbortModal.set(null);
      return Promise.resolve();
    },
  };
}

export function ConfirmAbortUploadModal() {
  const confirmAbortUploadModal = useConfirmAbortUploadModal();

  const onClose = () => {
    confirmAbortUploadModal.state?.abort();
    void confirmAbortUploadModal.close();
  };

  const onConfirm = () => {
    confirmAbortUploadModal.state?.proceed();
    void confirmAbortUploadModal.close();
  };

  return (
    <Modal
      isOpen={confirmAbortUploadModal.isOpen}
      onClose={onClose}
      title="Wait! Your files are still uploading!"
      size="md"
      shouldShowCloseButton
    >
      <ModalBody>
        <Paragraph mb="200">
          <Strong>If you leave Asset Library, the remaining uploads will be canceled.</Strong>
        </Paragraph>
        <Paragraph>Are you sure you want to continue?</Paragraph>
      </ModalBody>
      <ModalFooter>
        <Button variant="subtle" size="sm" onClick={onClose} mr="auto">
          No, go back
        </Button>
        <Button variant="secondary" size="sm" onClick={onConfirm} data-test-id="confirm-abort-upload-button">
          Yes, cancel upload
        </Button>
      </ModalFooter>
    </Modal>
  );
}
